module.exports = __webpack_public_path__ + "static/media/product-2.9f1b565c.svg";